import { arrayFrom } from "@/utils/array/array-from";

/**
 * List filter
 * - label 
 * - name 
 * - type: "select"
 * - cols: 4 
 * - placeholder
 * - description 
 * - values[]
 * - groups[]
 * - value (value[] - для multiple)
 * 
 * - multiple 
 * - searchable 
 * - checkboxValue 
 * - checkbox
 */

const multipleList = () => ({
    multiple: true,
    searchable: true,
    value: [],
});

const listCheckbox = () => ({
    checkboxValue: false,
    checkbox: "Все, кроме",
});

const listFormatters = {
    workerType: () => ({
        placeholder: "Все",
        value: { id: 0, label: "Все" },
    }),
    questCompletion: () => ({
        placeholder: "Любая",
        value: "",
        clearable: true,
    }),

    langs: () => ({
        ...multipleList(),
        placeholder: "Любые",
    }),

    programs: () => ({
        ...multipleList(),
        placeholder: "Любые",
    }),

    lastJobPosts: () => ({
        ...multipleList(),
        placeholder: "Любые",
    }),

    companyPosts: () => ({
        ...multipleList(),
        placeholder: "Любые",
    }),

    specialty: (field) => {
        const items = [];
        const groups = [];

        Object.entries(field.values).forEach(([key, value]) => {
            groups.push({ name: key, label: key });
            value.forEach((item) => {
                items.push({ value: item.id, label: item.name, group: key });
            });
        });

        return {
            ...listCheckbox(),
            ...multipleList(),

            placeholder: "Любая",
            values: items,
            groups,
            description: groups
                .map((i) => i.label)
                .slice(0, 3)
                .join(", "),
        };
    },

    category: (field) => {
        const mapDischargeValues = [];
        field.values.forEach((item) => {
            const c = mapDischargeValues.findIndex((i) => i.value === item.id);
            if (c === -1) mapDischargeValues.push({ value: item.id, label: item.value });
        });

        return {
            ...listCheckbox(),
            ...multipleList(),

            placeholder: "Любой",
            values: mapDischargeValues,
            description: mapDischargeValues
                .map((i) => i.value)
                .slice(0, 3)
                .join(","),
        };
    },

    age: () => ({
        ...listCheckbox(),
        ...multipleList(),

        placeholder: "Любой",
    }),

    company: (field) => {
        const values = Object.entries(field.values).map(([value, label]) => ({ value, label }));
        const description = "";

        return {
            ...listCheckbox(),
            ...multipleList(),

            placeholder: "Любое",
            values,
            description,
        };
    },

    default: () => ({
        ...listCheckbox(),
        ...multipleList(),
    }),
};

const listFormatter = (field) => {
    const { name, code } = field;

    let description = "";
    let mapValues = [];

    if (field.values) {
        const values = arrayFrom(field.values);

        description = values
            .map((item) => item && item.name)
            .filter(Boolean)
            .slice(0, 3)
            .join(", ");

        mapValues = values.map((item) => ({
            value: item.id,
            label: item.name,
        }));
    }

    const listFormatter = listFormatters[field.code] || listFormatters.default;

    const fieldSettings = {
        label: name,
        name: code,
        type: "select",
        cols: "4",
        placeholder: "Все",
        description,
        values: mapValues,
        ...listFormatter(field),
    };

    return fieldSettings;
};

/**
 * Boolean filter
 * - label
 * - name
 * - type: "switcher"
 * - cols: 2,
 * - value: false
 */

const booleanFormatter = (field) => {
    const { name, code } = field;
    return { label: name, name: code, type: "switcher", cols: "2", value: false };
};

/**
 * Range filter
 * - label
 * - name
 * - type: "range"
 * - cols: 3
 * - value: [0, 0]
 * - min: 0
 * - max: 200
 */

const WORK_DURATION_RANGE_FILTER = "workDuration";

const rangeFormatter = (field) => {
    const { name, code } = field;
    return {
        label: code === WORK_DURATION_RANGE_FILTER ? `${name}, мес.` : name,
        name: code,
        type: "range",
        cols: "3",
        value: [0, 0],
        min: 0,
        max: 200,
    };
};

/**
 * Input filter
 * - label
 * - name
 * - type: "text"
 * - cols: 3
 * - placeholder
 */

const NAME_OR_PHONE_TEXT_FILTER = "nameOrPhone";

const inputFormatter = (field) => {
    const { name, code } = field;

    return {
        label: name,
        name: code,
        type: "text",
        cols: "3",
        placeholder: code === NAME_OR_PHONE_TEXT_FILTER ? "Любое" : "Любые",
        value: "",
    };
};

const fieldFormatters = {
    list: listFormatter,
    boolean: booleanFormatter,
    range: rangeFormatter,
    input: inputFormatter,
};

export function getFilterSettings(field) {
    const formatter = fieldFormatters[field.type] || fieldFormatters.input;
    return formatter(field);
}
